import request from "./request";

// const lang = localSorage.getItem('language')
const lang = window.localStorage.getItem('language')

/* 首页内容 */
export const IndexContent = () => {
  return request({
    url: "/api/index/content",
    method: "post",
    data: {
      lang: lang
    },
  });
};
// 获取专家列表
export const ExpertList = (requestData) => {
  return request({
    url: "/api/expert/list",
    method: "post",
    data: {
      lang: lang,
      ...requestData
    },
  });
};
// 获取科室列表
export const ExpertDepartment = () => {
  return request({
    url: "/api/expert/department",
    method: "post",
    data: {
      lang: lang,
    },
  });
};
//获取专家详情
export const ExpertDetail = (requestData) => {
  return request({
    url: "/api/expert/detail",
    method: "post",
    data: {
      lang: lang,
      id: requestData
    },
  });
};
// 获取合作机构
export const Cooperation = (requestData) => {
  return request({
    url: "/api/cooperation",
    method: "post",
    data: {
      lang: lang,
      ...requestData
    },
  });
};
// 获取新闻列表
export const NewsList = (requestData) => {
  return request({
    url: "/api/news/list",
    method: "post",
    data: {
      lang: lang,
      ...requestData
    },
  });
};
// 获取文章列表
export const ArticleList = (requestData) => {
  return request({
    url: "/api/article/list",
    method: "post",
    data: {
      lang: lang,
      ...requestData
    },
  });
};
// 获取新闻列表参数
export const NewsCategory = () => {
  return request({
    url: "/api/news/category",
    method: "post",
    data: {
      lang: lang,
    },
  });
};
// 获取文章列表参数
export const ArticleParams = (requestData) => {
  return request({
    url: "/api/article/params",
    method: "post",
    data: {
      lang: lang,
      mid: requestData
    },
  });
};
// 获取栏目下文章详情
export const ArticleContent = (requestData) => {
  return request({
    url: "/api/article/content",
    method: "post",
    data: {
      lang: lang,
      ...requestData
    },
  });
};
// 获取文章详情
export const ArticleDetail = (id,token) => {
  return request({
    url: "/api/article/detail",
    method: "post",
    data: {
      lang: lang,
      id,
      token
    },
  });
};
//药品列表
export const DrugList = (requestData) => {
  return request({
    url: "/api/drug/list",
    method: "post",
    data: {
      lang: lang,
      ...requestData
    },
  });
};
//获取药品列表参数
export const DrugParams = () => {
  return request({
    url: "/api/drug/params",
    method: "post",
    data: {
      lang: lang,
    },
  });
};
//找药用药
export const FindDrug = () => {
  return request({
    url: "/api/find/drug",
    method: "post",
    data: {
      lang: lang,
    },
  });
};
// 患者咨询
export const LeaveHealth = (requestData) => {
  return request({
    url: "/api/leave/health",
    method: "post",
    data: {
      lang: lang,
      ...requestData
    },
  });
};
// 厂家+医生留言
export const Leave = (requestData) => {
  return request({
    url: "/api/leave",
    method: "post",
    data: {
      lang: lang,
      ...requestData
    },
  });
};

// 获取就诊流程
export const VisitProcess = () => {
  return request({
    url: "/api/visit/process",
    method: "post",
    data: {
      lang: lang,
    },
  });
};
// 获取交通方式
export const Transport = () => {
  return request({
    url: "/api/transport",
    method: "post",
    data: {
      lang: lang,
    },
  });
};
// 获取留言类型
export const LeaveTypes = (requestData) => {
  return request({
    url: "/api/leave/types",
    method: "post",
    data: {
      lang: lang,
      ptype: requestData
    },
  });
};

// 获取单页内容
export const MenuContent = (requestData) => {
  return request({
    url: "/api/menu/content",
    method: "post",
    data: {
      lang: lang,
      mid: requestData
    },
  });
};

// 获取视频列表
export const VideoList = (requestData) => {
  return request({
    url: "/api/video/list",
    method: "post",
    data: {
      lang: lang,
      ...requestData
    },
  });
};

// 获取视频标签
export const VideoTags = (requestData) => {
  return request({
    url: "/api/video/tags",
    method: "post",
    data: {
      lang: lang,
      mid: requestData
    },
  });
};


// 获取视频详情
export const VideoDetail = (requestData) => {
  return request({
    url: "/api/video/detail",
    method: "post",
    data: {
      lang: lang,
      id: requestData
    },
  });
};

// 留言介绍
export const LeaveIntro = (requestData) => {
  return request({
    url: "/api/leave/intro",
    method: "post",
    data: {
      lang: lang,
      ptype: requestData
    },
  });
};

//疾病百科
export const DiseaseList = () => {
  return request({
    url: "/api/disease/list",
    method: "post",
    data: {
      lang: lang,
    },
  });
};
//疾病分类列表
export const DiseaseCategory = () => {
  return request({
    url: "/api/disease/category",
    method: "post",
    data: {
      lang: lang,
    },
  });
};
//疾病百科详情
export const DiseaseDetail = (requestData) => {
  return request({
    url: "/api/disease/detail",
    method: "post",
    data: {
      lang: lang,
      mid: requestData
    },
  });
};

//疾病百科详情
export const DiseaseDetail2 = (requestData) => {
  return request({
    url: "/api/disease/v2/detail",
    method: "post",
    data: {
      lang: lang,
      mid: requestData
    },
  });
};

//底部导航
export const Other = () => {
  return request({
    url: "/api/other",
    method: "post",
    data: {
      lang: lang,
    },
  });
};
//顶部导航
export const Menus = () => {
  return request({
    url: "/api/menus",
    method: "post",
    data: {
      lang: lang,
    },
  });
};
//承诺书
export const Consent = () => {
  return request({
    url: "/api/leave/informed_consent",
    method: "post",
    data: {
      lang: lang,
    },
  });
};
//隐私政策
export const Policy = () => {
  return request({
    url: "/api/leave/privacy_policy",
    method: "post",
    data: {
      lang: lang,
    },
  });
};
//公益项目
export const ProjectList = () => {
  return request({
    url: "/api/project/list",
    method: "post",
    data: {
      lang: lang,
    },
  });
};
//公益项目详情
export const ProjectDeatil = (requestData) => {
  return request({
    url: "/api/project/detail",
    method: "post",
    data: {
      lang: lang,
      id: requestData
    },
  });
};

//服务协议
export const ServiceAgreement = () => {
  return request({
    url: "/api/service/agreement",
    method: "post",
    data: {
      lang: lang,
    },
  });
};


//订阅
export const subscribe = (id,token) => {
  return request({
    url: "/api/user/tag/fav",
    method: "post",
    data: {
      token: token,
      tag_id: id,
      lang: lang,
    },
  });
};

//我的订阅
export const mySubscribe = (requestData,token) => {
  return request({
    url: "/api/user/tag/list",
    method: "post",
    data: {
     is_fav: 1,
     lang: lang,
     mid: requestData,
     token: token,
    },
  });
};

//取消订阅
export const cancelSubscribe = (id,token) => {
  return request({
    url: "/api/user/tag/del",
    method: "post",
    data: {
      lang: lang,
      tag_id:id,
      token
    },
  });
};

//取消订阅
export const hotVideo = () => {
  return request({
    url: "/api/video/hot",
    method: "post",
    data: {
      lang: lang,
    },
  });
};

